import Vue from "vue";
import currencyFilter from './currencyFilter.js'
import toAirlineName from "./airlineFilter.js";
import duration from "./durationFilter.js";
import locationFilter from "./locationFilter.js"

Vue.filter("formatCurrency", currencyFilter.formatCurrency);
Vue.filter("currencySymbol", currencyFilter.currencySymbol);
Vue.filter("toAirlineName", toAirlineName);
Vue.filter("toCityName", locationFilter.toCityName);
Vue.filter("toAirportName", locationFilter.toAirportName);
Vue.filter("parseDuration", duration);
